import { render, staticRenderFns } from "./Theses.vue?vue&type=template&id=630e0d9e"
import script from "./Theses.vue?vue&type=script&lang=js"
export * from "./Theses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports